module.exports = __webpack_public_path__ + "static/media/suitable.0e6403d2.svg";